import ReactGA from "react-ga4";

/**
 * Track a purchase conversion event
 * @param {Object} options
 * @param {number} options.value - Total order value
 * @param {string} options.transactionId - Transaction ID
 * @param {string} options.currency - Currency code (defaults to TWD)
 */
export const trackPurchaseConversion = ({ value, transactionId, currency = "TWD" }) => {
  ReactGA.event({
    category: "ecommerce",
    action: "purchase",
    // This maps to the gtag 'conversion' event
    label: "conversion",
    value: Number(value),
    // These parameters will be included in the event payload
    send_to: process.env.REACT_APP_GTAG_ID,
    currency,
    "transaction_id": transactionId
  });

  // For debugging
  console.log(`Tracked purchase: ${transactionId}, ${value} ${currency}`);
};

/**
 * Track a Google Ads purchase conversion event
 * @param {Object} options
 * @param {number} options.value - Total order value
 * @param {string} options.transactionId - Transaction ID
 * @param {string} options.currency - Currency code (defaults to TWD)
 */
export const trackGoogleAdsConversion = ({ value, transactionId, currency = "TWD" }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': process.env.REACT_APP_GTAG_ADS_ID,
      'event_callback': () => {
        console.log(`Google Ads conversion tracked: ${transactionId}, ${value} ${currency}`);
      },
      'value': Number(value),
      'currency': currency,
      'transaction_id': transactionId
    });

    // For debugging
    console.log(`Tracked Google Ads conversion: ${transactionId}, ${value} ${currency}`);
  } else {
    console.warn('Google Ads gtag not available');
  }
};

/**
 * Track purchase conversion events across all platforms
 * @param {Object} options
 * @param {number} options.value - Total order value
 * @param {string} options.transactionId - Transaction ID
 * @param {string} options.currency - Currency code (defaults to TWD)
 */
export const trackAllPurchaseConversions = (options) => {
  trackPurchaseConversion(options);
  trackGoogleAdsConversion(options);
};